<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <div
      v-if="
        relativeRelations.relativeRelationsData != undefined &&
        relativeRelations.relativeRelationsData.length != 0
      "
    >
      <RelativeRelationsTable
        :relativeRelationsData="relativeRelations.relativeRelationsData"
        :relativeRelationData="relativeRelations.relativeRelation"
        v-on:setRelativeRelationData="
          relativeRelations.relativeRelation.fillData($event)
        "
        :pagination="relativeRelations.pagination"
      />

      <Pagination
        v-if="!isLoading"
        :paginationData="relativeRelations.pagination"
        v-on:changePage="changePage"
      />
      <RelativeRelationDelete
        :relativeRelationData="relativeRelations.relativeRelation"
        v-on:refresh="getAllRelativeRelations(1)"
      />
    </div>

    <RelativeRelationFloatBtns
      :theFilterData="relativeRelations.filterData"
      v-on:search="search($event)"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import RelativeRelationsTable from "@/components/settings/settingsOther/relativeRelations/RelativeRelationsTable.vue";
import RelativeRelationDelete from "@/components/settings/settingsOther/relativeRelations/RelativeRelationDelete.vue";
import RelativeRelationFloatBtns from "@/components/settings/settingsOther/relativeRelations/RelativeRelationFloatBtns.vue";
import Pagination from "@/components/general/Pagination.vue";
import createToastMixin from "@/utils/create-toast-mixin";
import RelativeRelations from "@/models/settings/settingsOther/relativeRelations/RelativeRelations";

export default {
  name: "RelativeRelations",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    RelativeRelationsTable,
    RelativeRelationDelete,
    RelativeRelationFloatBtns,
    Pagination,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken,
      language: localStorage.getItem("userLanguage") || "ar",
      relativeRelations: new RelativeRelations(),
    };
  },
  methods: {
    changePage(page) {
      this.relativeRelations.pagination.selfPage = page;
      this.getAllRelativeRelations();
    },
    search(data) {
      this.relativeRelations.filterData.fillData(data);
      this.relativeRelations.relativeRelationsData = [];
      this.getAllRelativeRelations();
    },
    async getAllRelativeRelations() {
      this.isLoading = true;
      try {
        const response =
          await this.relativeRelations.relativeRelation.getAllRelativeRelations(
            this.language,
            this.userAuthorizeToken,
            this.relativeRelations.pagination,
            this.relativeRelations.filterData
          );

        if (response.data.status == STATUS.SUCCESS) {
          this.exceptionMsg = null;
          this.relativeRelations.fillData(response.data);
        } else if (response.data.status == STATUS.NO_CONTENT) {
          this.relativeRelations.relativeRelationsData = [];
          this.exceptionImg = "";
          this.exceptionMsg = response.data.msg;
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.relativeRelations.relativeRelationsData = [];
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.relativeRelations.relativeRelationsData = [];
          this.exceptionImg = "";
          this.exceptionMsg = response.data.msg;
        }
      } catch (error) {
        this.relativeRelations.relativeRelationsData = [];
        this.exceptionImg = "illustrator-somethingWrong.svg";
        this.exceptionMsg = this.$t("errorCatch");
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getAllRelativeRelations();
  },
};
</script>

<style lang="scss"></style>
